import { useIsMobile } from "@src/Hooks/useIsMobile"
import * as React from "react"
import * as ReactTooltip from "react-tooltip"

import { TooltipContentWrapper } from "../Common"
import { TooltipStyled } from "./styles"

interface ITooltipProps {
  id: string
  anchorSelect?: string
  width?: string
  maxWidth?: string
  contentMaxWidth?: string
  tooltipClassName?: string
  content: JSX.Element
  clickable?: boolean
  place?: ReactTooltip.PlacesType
  positionStrategy?: ReactTooltip.PositionStrategy
  effect?: "float" | "solid"
  type?: ReactTooltip.VariantType
  textAlign?: "right" | "left" | "center"
  offset?: number
  pointerEvents?: string
  defaultIsOpen?: boolean
  isOpen?: boolean
  delayHide?: number
}

const Tooltip: React.FC<ITooltipProps> = ({
  id,
  anchorSelect,
  content,
  width = "auto",
  maxWidth,
  contentMaxWidth,
  tooltipClassName,
  place = "top",
  positionStrategy = "fixed",
  effect = "solid",
  type = "dark",
  textAlign = "left",
  clickable = false,
  pointerEvents,
  offset,
  defaultIsOpen,
  isOpen,
  delayHide = 300,
}) => {
  const isMobile = useIsMobile()
  const tooltipClassNames = ["tooltip-content-custom", tooltipClassName]
    .filter(Boolean)
    .join(" ")

  return (
    <TooltipStyled
      width={width}
      maxWidth={maxWidth}
      type={type}
      textAlign={textAlign}
      pointerEvents={pointerEvents}
    >
      <ReactTooltip.Tooltip
        className={tooltipClassNames}
        id={id}
        anchorSelect={anchorSelect}
        variant={type}
        float={effect === "float"}
        place={place}
        positionStrategy={positionStrategy}
        clickable={clickable}
        delayHide={delayHide}
        delayShow={150}
        offset={offset}
        openOnClick={isMobile}
        defaultIsOpen={defaultIsOpen}
        isOpen={isOpen}
      >
        <TooltipContentWrapper $maxWidth={contentMaxWidth}>
          {content}
        </TooltipContentWrapper>
      </ReactTooltip.Tooltip>
    </TooltipStyled>
  )
}

export default React.memo(Tooltip)
